import { useNavigationListener } from './navigation-listener.mjs';

function NavigationListener({
  onNavigation
}) {
  useNavigationListener(onNavigation);
  return null;
}

export { NavigationListener };
